import React, { useContext } from "react"
import { Icon } from "semantic-ui-react"
import { BasketContext } from "../../context/BasketProvider"
import PlainButton from "../button/PlainButton"
import styled from "styled-components"

const Container = styled(PlainButton)`
  margin: 0;
  position: relative;
  padding: 5px;
  cursor: pointer;

  i {
    margin-left: 10px;
  }

  div {
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 20px;
    background-color: #055b6e;
    width: 20px;
    height: 20px;
    border: 1px solid white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    padding-left: 1px;
    //color: hsla(0,0%,0%,0.8);
    color: white;
  }
`

const BasketPreview = () => {
  const basketContext = useContext(BasketContext)
  const {
    toggle,
    basket: { items },
  } = basketContext
  let totalQuantity = 0
  items.forEach(item => {
    totalQuantity += item.quantity
  })
  return (
    <Container onClick={toggle}>
      <Icon name="shopping bag" size="large" />
      {totalQuantity > 0 && <div>{totalQuantity}</div>}
    </Container>
  )
}

export default BasketPreview
